import { useEffect, useState } from "react";
import api from "../constant/api";
import { motion, AnimatePresence } from "framer-motion";

export default function Inventory() {

  /* ========================================= */
  /* STATE */
  /* ========================================= */

  const [products, setProducts] =
    useState([]);

  const [selectedProduct,
    setSelectedProduct] =
    useState(null);

  const [search, setSearch] =
    useState("");

    const [returnHistory,
  setReturnHistory] =
  useState([]);

  const [stockFilter,
    setStockFilter] =
    useState("all");

  const [activeTab,
    setActiveTab] =
    useState("purchase");

  const [purchaseHistory,
    setPurchaseHistory] =
    useState([]);

  const [salesHistory,
    setSalesHistory] =
    useState([]);

  /* PAGINATION */

  const [currentPage,
    setCurrentPage] =
    useState(1);

  const itemsPerPage = 6;

  /* ========================================= */
  /* FETCH INVENTORY */
  /* ========================================= */

  useEffect(() => {

    fetchInventory();

  }, []);

  

  const fetchInventory = async () => {

    try {

      const res = await api.get(
        "/inventory/getInventory"
      );

      setProducts(
        res.data.data || []
      );

    } catch (err) {

      console.log(err);

    }

  };

  /* RETURN HISTORY */

  /* ========================================= */
  /* OPEN HISTORY */
  /* ========================================= */

  const openHistory = async (
  product
) => {

  try {

    setSelectedProduct(product);

    /* PURCHASE HISTORY */

    const purchaseRes =
      await api.get(
        `/inventory/getPurchaseHistory/${product.product_id}`
      );

    setPurchaseHistory(
      purchaseRes.data.data || []
    );

    /* SALES HISTORY */

    const salesRes =
      await api.get(
        `/inventory/getHistory/${product.product_id}`
      );

    setSalesHistory(
      salesRes.data.data || []
    );

    /* RETURN HISTORY */

    const returnRes =
      await api.get(
        `/inventory/getReturnHistory/${product.product_id}`
      );

    setReturnHistory(
      returnRes.data.data || []
    );

    setActiveTab("purchase");

  } catch (err) {

    console.log(err);

  }

};

  /* ========================================= */
  /* FILTER PRODUCTS */
  /* ========================================= */

  const filteredProducts =
    products.filter((p) => {

      const matchesSearch =
        p.product_name
          ?.toLowerCase()
          .includes(
            search.toLowerCase()
          );

      if (!matchesSearch)
        return false;

      if (
        stockFilter === "low"
      ) {

        return (
          Number(p.qty) < 10 &&
          Number(p.qty) > 0
        );

      }

      if (
        stockFilter === "out"
      ) {

        return (
          Number(p.qty) <= 0
        );

      }

      if (
        stockFilter === "stock"
      ) {

        return (
          Number(p.qty) > 0
        );

      }

      return true;

    });


  /* ========================================= */
  /* PAGINATION */
  /* ========================================= */

  const totalPages =
    Math.ceil(
      filteredProducts.length /
      itemsPerPage
    );

  const startIndex =
    (currentPage - 1) *
    itemsPerPage;

  const endIndex =
    startIndex +
    itemsPerPage;

  const currentProducts =
    filteredProducts.slice(
      startIndex,
      endIndex
    );

  return (

    <div className="p-4 bg-gray-100 min-h-screen">

      {/* HEADER */}

      <div className="
        flex
        flex-col
        md:flex-row
        md:items-center
        md:justify-between
        gap-3
        mb-6
      ">

        <div>

          <h1 className="
            text-3xl
            font-bold
            text-gray-800
          ">
            Inventory Module
          </h1>

          <p className="
            text-gray-500
            text-sm
          ">
            Manage stocks & history
          </p>

        </div>

        {/* SEARCH */}

        <input
          type="text"
          placeholder="Search product..."
          value={search}
          onChange={(e) => {

            setSearch(
              e.target.value
            );

            setCurrentPage(1);

          }}
          className="
            border
            border-gray-300
            px-4
            py-3
            rounded-2xl
            shadow-sm
            outline-none
            focus:ring-2
            focus:ring-blue-400
            bg-white
          "
        />

      </div>

      {/* TOP CARDS */}

      <div className="
        grid
        grid-cols-2
        md:grid-cols-4
        gap-4
        mb-6
      ">

        {/* TOTAL */}

        <div
          onClick={() => {

            setStockFilter(
              "all"
            );

            setCurrentPage(1);

          }}
          className={`
            cursor-pointer
            rounded-2xl
            p-4
            shadow-lg
            text-white
            transition
            hover:scale-[1.03]
            ${
              stockFilter === "all"
                ? "ring-4 ring-blue-200"
                : ""
            }
            bg-gradient-to-r
            from-blue-600
            to-blue-400
          `}
        >

          <p className="
            text-sm
            opacity-80
          ">
            Total Products
          </p>

          <h2 className="
            text-3xl
            font-bold
            mt-2
          ">
            {products.length}
          </h2>

        </div>

        {/* STOCK */}

        <div
          onClick={() => {

            setStockFilter(
              "stock"
            );

            setCurrentPage(1);

          }}
          className={`
            cursor-pointer
            rounded-2xl
            p-4
            shadow-lg
            text-white
            transition
            hover:scale-[1.03]
            ${
              stockFilter === "stock"
                ? "ring-4 ring-green-200"
                : ""
            }
            bg-gradient-to-r
            from-green-600
            to-green-400
          `}
        >

          <p className="
            text-sm
            opacity-80
          ">
            Total Stock
          </p>

          <h2 className="
            text-3xl
            font-bold
            mt-2
          ">

            {
              products.reduce(
                (sum, item) =>
                  sum +
                  Number(
                    item.qty || 0
                  ),
                0
              )
            }

          </h2>

        </div>

        {/* LOW STOCK */}

        <div
          onClick={() => {

            setStockFilter(
              "low"
            );

            setCurrentPage(1);

          }}
          className={`
            cursor-pointer
            rounded-2xl
            p-4
            shadow-lg
            text-white
            transition
            hover:scale-[1.03]
            ${
              stockFilter === "low"
                ? "ring-4 ring-orange-200"
                : ""
            }
            bg-gradient-to-r
            from-orange-500
            to-orange-300
          `}
        >

          <p className="
            text-sm
            opacity-80
          ">
            Low Stock
          </p>

          <h2 className="
            text-3xl
            font-bold
            mt-2
          ">

            {
              products.filter(
                item =>
                  Number(
                    item.qty
                  ) < 10 &&
                  Number(
                    item.qty
                  ) > 0
              ).length
            }

          </h2>

        </div>

        {/* OUT STOCK */}

        <div
          onClick={() => {

            setStockFilter(
              "out"
            );

            setCurrentPage(1);

          }}
          className={`
            cursor-pointer
            rounded-2xl
            p-4
            shadow-lg
            text-white
            transition
            hover:scale-[1.03]
            ${
              stockFilter === "out"
                ? "ring-4 ring-red-200"
                : ""
            }
            bg-gradient-to-r
            from-red-600
            to-red-400
          `}
        >

          <p className="
            text-sm
            opacity-80
          ">
            Out Of Stock
          </p>

          <h2 className="
            text-3xl
            font-bold
            mt-2
          ">

            {
              products.filter(
                item =>
                  Number(
                    item.qty
                  ) <= 0
              ).length
            }

          </h2>

        </div>

      </div>

      <div className="
  flex
  items-center
  justify-center
  gap-2
 mt-12
  mb-6
  flex-wrap
">

  {/* PREV */}
  <button
    disabled={currentPage === 1}
    onClick={() =>
      setCurrentPage(
        currentPage - 1
      )
    }
    className={`
      w-10
      h-10
      rounded-full
      flex
      items-center
      justify-center
      text-sm
      font-bold
      shadow-sm
      transition
      ${
        currentPage === 1
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-white hover:bg-black hover:text-white"
      }
    `}
  >
    ❮
  </button>

  {/* ONLY 3 PAGE SHOW */}
  {Array.from({ length: totalPages })
    .map((_, i) => i + 1)
    .filter((page) => {

      if (totalPages <= 3) {
        return true;
      }

      if (currentPage === 1) {
        return page <= 3;
      }

      if (currentPage === totalPages) {
        return page >= totalPages - 2;
      }

      return (
        page >= currentPage - 1 &&
        page <= currentPage + 1
      );

    })
    .map((page) => (

      <button
        key={page}
        onClick={() =>
          setCurrentPage(page)
        }
        className={`
          w-10
          h-10
          rounded-full
          text-sm
          font-bold
          transition
          shadow-sm
          ${
            currentPage === page
              ? "bg-black text-white scale-110"
              : "bg-white hover:bg-gray-100"
          }
        `}
      >
        {page}
      </button>

    ))}

  {/* NEXT */}
  <button
    disabled={
      currentPage === totalPages
    }
    onClick={() =>
      setCurrentPage(
        currentPage + 1
      )
    }
    className={`
      w-10
      h-10
      rounded-full
      flex
      items-center
      justify-center
      text-sm
      font-bold
      shadow-sm
      transition
      ${
        currentPage === totalPages
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-white hover:bg-black hover:text-white"
      }
    `}
  >
    ❯
  </button>

</div>

      {/* PRODUCT GRID */}

      <div className="
        grid
        grid-cols-1
        sm:grid-cols-2
        lg:grid-cols-3
        xl:grid-cols-6
        gap-5
      ">

        {currentProducts.map(
          (item) => (

          <motion.div
            key={item.product_id}
            whileHover={{
              y: -5,
            }}
            className="
              bg-white/90
              backdrop-blur-xl
              rounded-3xl
              shadow-lg
              border
              overflow-hidden
            "
          >

            {/* IMAGE */}

            <div className="relative">

              <img
                src={
                  item.images
                    ? `https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.images}`
                    : "https://via.placeholder.com/300"
                }
                alt=""
                className="
                  w-full
                  h-60
                  object-cover
                "
              />

              {/* STOCK */}

              <div className="
                absolute
                top-3
                right-3
              ">

                <span className={`
                  px-3
                  py-1
                  rounded-full
                  text-xs
                  font-bold
                  shadow
                  ${
                    Number(
                      item.qty
                    ) <= 0
                      ? "bg-red-100 text-red-600"
                      : Number(
                          item.qty
                        ) < 10
                      ? "bg-orange-100 text-orange-600"
                      : "bg-green-100 text-green-600"
                  }
                `}>

                Stock :  {" "}
{item.qty} Box / {" "}
{item.pic || 0}

                </span>

              </div>

            </div>

            {/* CONTENT */}

            <div className="p-4">

              <h2 className="
                font-bold
                text-lg
                text-gray-800
                line-clamp-2
              ">
                {item.product_name}
              </h2>

              <div className="
                grid
                grid-cols-2
                gap-3
                mt-4
              ">

                <div className="
                  bg-blue-50
                  rounded-2xl
                  p-3
                ">

                  <p className="
                    text-xs
                    text-gray-400
                  ">
                    Price
                  </p>

                  <h3 className="
                    text-blue-600
                    font-bold
                    text-lg
                  ">
                    ₹{item.price}
                  </h3>

                </div>

                <div className="
                  bg-purple-50
                  rounded-2xl
                  p-3
                ">

                  <p className="
                    text-xs
                    text-gray-400
                  ">
                    Category
                  </p>

                  <h3 className="
                    text-purple-600
                    font-bold
                    text-sm
                  ">
                    {
                      item.product_category ||
                      "Tiles"
                    }
                  </h3>

                </div>

              </div>

              <button
                onClick={() =>
                  openHistory(item)
                }
                className="
                  mt-5
                  w-full
                  bg-gradient-to-r
                  from-blue-500
                  to-indigo-500
                  hover:scale-[1.02]
                  transition
                  text-white
                  py-3
                  rounded-2xl
                  font-semibold
                  shadow-lg
                "
              >
                📦 View Inventory History
              </button>

            </div>

          </motion.div>

        ))}

      </div>


     {/* PAGINATION */}

{/* PAGINATION */}
<div className="
  flex
  items-center
  justify-center
  gap-2
  mt-8
  flex-wrap
">

  {/* PREV */}
  <button
    disabled={currentPage === 1}
    onClick={() =>
      setCurrentPage(
        currentPage - 1
      )
    }
    className={`
      w-10
      h-10
      rounded-full
      flex
      items-center
      justify-center
      text-sm
      font-bold
      shadow-sm
      transition
      ${
        currentPage === 1
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-white hover:bg-black hover:text-white"
      }
    `}
  >
    ❮
  </button>

  {/* ONLY 3 PAGE SHOW */}
  {Array.from({ length: totalPages })
    .map((_, i) => i + 1)
    .filter((page) => {

      if (totalPages <= 3) {
        return true;
      }

      if (currentPage === 1) {
        return page <= 3;
      }

      if (currentPage === totalPages) {
        return page >= totalPages - 2;
      }

      return (
        page >= currentPage - 1 &&
        page <= currentPage + 1
      );

    })
    .map((page) => (

      <button
        key={page}
        onClick={() =>
          setCurrentPage(page)
        }
        className={`
          w-10
          h-10
          rounded-full
          text-sm
          font-bold
          transition
          shadow-sm
          ${
            currentPage === page
              ? "bg-black text-white scale-110"
              : "bg-white hover:bg-gray-100"
          }
        `}
      >
        {page}
      </button>

    ))}

  {/* NEXT */}
  <button
    disabled={
      currentPage === totalPages
    }
    onClick={() =>
      setCurrentPage(
        currentPage + 1
      )
    }
    className={`
      w-10
      h-10
      rounded-full
      flex
      items-center
      justify-center
      text-sm
      font-bold
      shadow-sm
      transition
      ${
        currentPage === totalPages
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-white hover:bg-black hover:text-white"
      }
    `}
  >
    ❯
  </button>

</div>
     

<AnimatePresence>

  {selectedProduct && (

    <motion.div
      className="
        fixed inset-0
        bg-black/70
        backdrop-blur-sm
        flex items-center justify-center
        z-[9999]
        p-3
      "
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() =>
        setSelectedProduct(null)
      }
    >

      <motion.div
        initial={{
          scale: 0.9,
          y: 40,
        }}
        animate={{
          scale: 1,
          y: 0,
        }}
        exit={{
          scale: 0.9,
          y: 40,
        }}
        onClick={(e) =>
          e.stopPropagation()
        }
        className="
          bg-white
          w-full
          max-w-5xl
          rounded-3xl
          overflow-hidden
          shadow-2xl
        "
      >

        {/* HEADER */}

        <div className="
          bg-gradient-to-r
          from-gray-900
          to-gray-700
          text-white
          p-5
          flex
          justify-between
          items-center
        ">

          <div>

            <h2 className="
              text-2xl
              font-bold
            ">
              {
                selectedProduct.product_name
              }
            </h2>

            <p className="
              text-sm
              opacity-80
            ">
              Inventory History
            </p>

          </div>

          <button
            onClick={() =>
              setSelectedProduct(null)
            }
            className="
              text-2xl
            "
          >
            ✖
          </button>

        </div>

        {/* TABS */}

        <div className="
          flex
          gap-3
          p-4
          bg-gray-100
          border-b
        ">

          <button
            onClick={() =>
              setActiveTab(
                "purchase"
              )
            }
            className={`
              px-5
              py-2
              rounded-2xl
              font-semibold
              transition
              ${
                activeTab ===
                "purchase"
                  ? "bg-blue-600 text-white"
                  : "bg-white border text-gray-700"
              }
            `}
          >
            Purchase History
          </button>

          <button
            onClick={() =>
              setActiveTab(
                "sales"
              )
            }
            className={`
              px-5
              py-2
              rounded-2xl
              font-semibold
              transition
              ${
                activeTab ===
                "sales"
                  ? "bg-green-600 text-white"
                  : "bg-white border text-gray-700"
              }
            `}
          >
            Sales History
          </button>

          <button
  onClick={() =>
    setActiveTab(
      "return"
    )
  }
  className={`
    px-5
    py-2
    rounded-2xl
    font-semibold
    transition
    ${
      activeTab ===
      "return"
        ? "bg-red-600 text-white"
        : "bg-white border text-gray-700"
    }
  `}
>
  Return History
</button>

        </div>

        {/* BODY */}

        <div className="
          p-5
          max-h-[75vh]
          overflow-y-auto
          bg-gray-50
        ">

          {/* PURCHASE TAB */}

          {activeTab ===
            "purchase" && (

            <div className="
              space-y-4
            ">

              {purchaseHistory.length ===
                0 && (

                <div className="
                  text-center
                  py-20
                  text-gray-400
                ">
                  No Purchase History
                </div>

              )}

              {purchaseHistory.map(
                (h) => (

                <div
                  key={h.history_id}
                  className="
                    bg-white
                    border
                    rounded-2xl
                    p-4
                    shadow-sm
                  "
                >

                  <div className="
                    flex
                    justify-between
                    items-start
                  ">

                    <div>

                      <h3 className="
                        text-lg
                        font-bold
                      ">
                        Purchase #
                        {
                          h.purchase_id
                        }
                      </h3>

                      <p className="
                        text-sm
                        text-gray-500
                        mt-1
                      ">
                        Supplier :
                        {" "}
                        {
                          h.supplier_name
                        }
                      </p>

                      <p className="
                        text-sm
                        text-gray-500
                      ">
                        Qty :
                        {" "}
                        {h.qty}
                      </p>

                    </div>

                    <div className="
                      text-right
                    ">

                      <span
                        className="
                          bg-blue-100
                          text-blue-600
                          px-3
                          py-1
                          rounded-full
                          text-xs
                          font-bold
                        "
                      >
                        PURCHASE
                      </span>

                      <h2 className="
                        text-2xl
                        font-bold
                        text-green-600
                        mt-3
                      ">
                        ₹{h.total}
                      </h2>

                    </div>

                  </div>

                  <div className="
                    border-t
                    mt-4
                    pt-3
                    text-xs
                    text-gray-400
                  ">

                    {h.created_at}

                  </div>

                </div>

              ))}

            </div>

          )}

          {/* SALES TAB */}

          {activeTab ===
            "sales" && (

            <div className="
              space-y-4
            ">

              {salesHistory.length ===
                0 && (

                <div className="
                  text-center
                  py-20
                  text-gray-400
                ">
                  No Sales History
                </div>

              )}

              {salesHistory.map(
                (h) => (

                <div
                  key={h.history_id}
                  className="
                    bg-white
                    border
                    rounded-2xl
                    p-4
                    shadow-sm
                  "
                >

                  <div className="
                    flex
                    justify-between
                    items-start
                  ">

                    <div>

                      <h3 className="
                        text-lg
                        font-bold
                      ">
                        Order #
                        {h.order_id}
                      </h3>

                      <p className="
                        text-sm
                        text-gray-500
                        mt-1
                      ">
                        {h.name}
                      </p>

                      <p className="
                        text-sm
                        text-gray-400
                      ">
                        {h.phone}
                      </p>

                    </div>

                    <div className="
                      text-right
                    ">

                      <span
                        className="
                          bg-red-100
                          text-red-600
                          px-3
                          py-1
                          rounded-full
                          text-xs
                          font-bold
                        "
                      >
                        SALES
                      </span>

                      <h2 className="
                        text-2xl
                        font-bold
                        text-red-600
                        mt-3
                      ">
                        -{h.qty}
                      </h2>

                      <p className="
                        text-sm
                        text-green-600
                        font-bold
                      ">
                        ₹{h.price}
                      </p>

                    </div>

                  </div>

                  <div className="
                    border-t
                    mt-4
                    pt-3
                    text-xs
                    text-gray-400
                  ">

                    {h.created_at}

                  </div>

                </div>

              ))}

            </div>

          )}

          {/* RETURN TAB */}

{activeTab ===
  "return" && (

  <div className="
    space-y-4
  ">

    {returnHistory.length ===
      0 && (

      <div className="
        text-center
        py-20
        text-gray-400
      ">
        No Return History
      </div>

    )}

    {returnHistory.map(
      (h) => (

      <div
        key={h.return_id}
        className="
          bg-white
          border
          rounded-2xl
          p-4
          shadow-sm
        "
      >

        <div className="
          flex
          justify-between
          items-start
        ">

          <div>

            <h3 className="
              text-lg
              font-bold
            ">
              Order #
              {h.order_id}
            </h3>

            <p className="
              text-sm
              text-gray-500
              mt-1
            ">
              {h.name}
            </p>

            <p className="
              text-sm
              text-gray-400
            ">
              {h.phone}
            </p>

            <p className="
              text-sm
              text-red-500
              mt-1
            ">
              Reason :
              {" "}
              {h.reason || "-"}
            </p>

          </div>

          <div className="
            text-right
          ">

            <span
              className="
                bg-red-100
                text-red-600
                px-3
                py-1
                rounded-full
                text-xs
                font-bold
              "
            >
              RETURN
            </span>

            <h2 className="
              text-2xl
              font-bold
              text-green-600
              mt-3
            ">
              +{h.qty}
            </h2>

            <p className="
              text-sm
              text-blue-600
              font-bold
            ">
              PCS : {h.pcs}
            </p>

          </div>

        </div>

        <div className="
          border-t
          mt-4
          pt-3
          text-xs
          text-gray-400
        ">

          {h.created_at}

        </div>

      </div>

    ))}

  </div>

)}

        </div>

      </motion.div>

    </motion.div>

  )}

</AnimatePresence>

    </div>

  );

}